"use strict";

import angular from "angular";
import { ChatwootAdapter } from "../../presentation/adpters/ChatwootAdapter/ChatwootAdapter";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { AccountingEntity } from "../../entity/AccountingEntity";
import {
    FEATURE_PLAN_VALUE,
    FEATURES_LIBERAVEIS
} from "../accountings/accountings.constants";
import { Accounting } from "../../gateway/Accounting/Accounting";
import { AccountingPlanHttpGateway } from "../../gateway/AccountingPlan/AccountingPlanHttpGateway";
import { User } from "../../gateway/User/User";
import {
    ConsultiveAccessService,
    CONSULTIVE_FEATURE
} from "../../presentation/services/ConsultiveAccessService";
import { LocalStoreService } from "../../presentation/services/LocalStoreService";
import {
    accountingUsers,
    accoutingTrialUsers,
    nucontersUsers
} from "../../utils/users-roles/users-roles";

angular.module("nucont.accounting").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting", {
        url: "contabilidade/:accountingId?accIdReference",
        params: {
            accountingId: {
                value: null
            },
            accIdReference: { value: null, dynamic: true }
        },
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting" */ "./accounting.view.component"
            ).then(() => $ocLazyLoad.inject("nucont.accounting"));
        },
        data: {
            rolesGuard: [
                ...nucontersUsers,
                ...accountingUsers,
                ...accoutingTrialUsers
            ]
        },
        views: {
            "main@": {
                component: "adminLayoutComponent"
            },
            "admin@nucont.accounting": {
                component: "accountingViewComponent"
            }
        },
        resolve: {
            jwtVerified: [
                "JWTService",
                (JWTService) => JWTService.verifyTokenOnce()
            ],
            user: [
                () => {
                    let count = 0;
                    return new Promise((resolve, reject) => {
                        const checkUser = () => {
                            console.log("CHECK USER 1");
                            if (count > 3) return resolve(true);
                            if (new UserDataAdapter().user()?.role) {
                                return resolve(true);
                            } else {
                                setTimeout(() => {
                                    count++;
                                    checkUser();
                                }, 500);
                            }
                        };
                        checkUser();
                    });
                }
            ],
            navigationConfig: [
                "$stateParams",
                "NavigationService",
                ($stateParams, NavigationService) => {
                    NavigationService.setParams(
                        "accountingId",
                        $stateParams.accountingId
                    );
                    NavigationService.setHref();
                }
            ],
            accountingData: [
                "$stateParams",
                "$state",
                "UserProfileSidenavService",
                "LayoutService",
                "AccountingFactory",
                "AccountingDataService",
                "JourneyService",
                "JWTService",
                async (
                    $stateParams,
                    $state,
                    UserProfileSidenavService,
                    LayoutService,
                    AccountingFactory,
                    AccountingDataService,
                    JourneyService,
                    JWTService
                ) => {
                    if (
                        !$stateParams.accIdReference &&
                        !$stateParams.accountingId
                    )
                        return $state.go("nucont.accountings.customers");
                    const AccountingGetaway = new Accounting();
                    const UserGateway = new User();
                    const accountingId =
                        $state.params.accIdReference ||
                        $state.params.accountingId ||
                        $stateParams.accIdReference ||
                        $stateParams.accountingId;
                    const accountingData = await AccountingGetaway.getById(
                        accountingId
                    );
                    if (!accountingData) {
                        console.log("SIGN OUT 2");
                        JWTService.signout();
                        return {};
                    }
                    JourneyService.reset();
                    JourneyService.configSystemsByPreferences(
                        accountingData.preferences?.mySystems,
                        accountingData.preferences?.onboarding
                    );
                    const localStoreService = new LocalStoreService();
                    localStoreService.setItem("accounting", {
                        _id: accountingData?._id,
                        name: accountingData?.name,
                        plan: accountingData?.plan?.name,
                        contract: accountingData?.contract,
                        status: accountingData?.status,
                        createdAt: accountingData?.createdAt
                    });
                    UserProfileSidenavService.setAccounting(accountingData);
                    AccountingFactory.setDocument(accountingData);
                    new ChatwootAdapter().setContabilidade(accountingData);
                    const accountingEntity = AccountingEntity.restore(
                        accountingData
                    );
                    AccountingDataService.setEntity(accountingEntity);
                    const noShow = UserGateway.checkPermission({
                        roles: new UserDataAdapter().user()?.roles,
                        granted: ["Empresa"]
                    });
                    let isDefaulter = false;
                    if (noShow) {
                        isDefaulter = false;
                    } else {
                        isDefaulter = accountingEntity.isDefaulter();
                    }
                    LayoutService.setAttrs([
                        {
                            object: "alertNotification",
                            path: "enabled",
                            value: isDefaulter
                        }
                    ]);
                    return accountingData;
                }
            ],
            accountingPlanEntity: [
                "accountingData",
                "NavigationService",
                "AccountingPlanService",
                "JWTService",
                async (
                    accountingData,
                    NavigationService,
                    AccountingPlanService,
                    JWTService
                ) => {
                    const accountingPlanHttpGateway = new AccountingPlanHttpGateway();
                    const contract = accountingData?.contract;
                    const accountingPlanEntity = await accountingPlanHttpGateway.getPlanByName(
                        contract
                    );
                    if (!accountingPlanEntity.props._id) {
                        console.log("SIGN OUT 3");
                        JWTService.signout();
                        return accountingPlanEntity;
                    }
                    // O override por contabilidade entra como se fosse feature contratada, para
                    // que o gate de menu por `accountingPlan.features` enxergue os dois caminhos
                    // de acesso sem saber que existem dois. A entidade é nova a cada chamada do
                    // gateway, então isto não vaza para o documento do plano.
                    if (
                        ConsultiveAccessService.resolve({
                            accountingData,
                            accountingPlanEntity
                        })
                    ) {
                        accountingPlanEntity.hireFeature({
                            value: CONSULTIVE_FEATURE,
                            label: "Agente Consultivo (Central Consultiva)"
                        });
                    }
                    // Mesma ideia do Agente Consultivo, um trilho acima: cada análise liberada
                    // por contabilidade (`preferences.features`) entra como feature contratada,
                    // e o gate de menu por `requiredFeatures` passa a enxergá-la sem precisar de
                    // um mecanismo novo de esconder item.
                    //
                    // Liberar é condição necessária e não suficiente: o Híbrido também depende de
                    // Domínio com integração fiscal ativa, e quem confere isso é o próprio
                    // Analysis ao abrir — aqui não há a carteira em mãos para perguntar.
                    const liberadas = accountingData?.preferences?.features || {};
                    // Só as que viram item de menu têm valor de plano; Funcionários é aba nos
                    // painéis da empresa e lê a liberação direto, sem passar por aqui.
                    FEATURES_LIBERAVEIS.forEach((feature) => {
                        if (liberadas[feature.key] !== true) return;
                        if (!FEATURE_PLAN_VALUE[feature.key]) return;
                        accountingPlanEntity.hireFeature({
                            value: FEATURE_PLAN_VALUE[feature.key],
                            label: `Análise ${feature.label}`
                        });
                    });
                    NavigationService.setValidationsContract(
                        accountingPlanEntity
                    );
                    new ChatwootAdapter().setSuporteContratado(
                        accountingPlanEntity.isContractedFeature({
                            value: "Support"
                        })
                    );
                    AccountingPlanService.init({
                        accountingPlanEntity
                    });
                    return accountingPlanEntity;
                }
            ],
            isAccountingBlocked: [
                "$state",
                "accountingData",
                "JWTService",
                async ($state, accountingData, JWTService) => {
                    setTimeout(() => {
                        if (
                            $state.current.name ===
                            "nucont.accounting.mySubscription"
                        )
                            return false;
                        const accountingEntity = new AccountingEntity(
                            accountingData
                        );
                        const isBlocked = accountingEntity.isAccessBlockedByFinancial(
                            {
                                user: new UserDataAdapter().user()
                            }
                        );
                        if (isBlocked) {
                            console.log("SIGN OUT 4");
                            JWTService.signout();
                        }
                    }, 1000);
                }
            ]
        }
    });
}
